import { ADMINISTRATOR, FACULTY_ADMIN, UNIVERSITY_ADMIN, FACULTY, UNIVERSITY } from './roles';

export const getNumberedOptions = (min, max, incrementation = 1) => {
    let numberedOptions = [];

    for (let i = min; i <= max; i += incrementation) {
        numberedOptions = [...numberedOptions, {
            key: i,
            value: i,
            text: i.toString(),
        }];
    }

    numberedOptions.push({
        key: 0,
        value: 0,
        text: 'Sve',
    });

    return numberedOptions;
};

export const getTotalNumberOfPages = (total, resultsPerPage) => (
    Math.ceil(total / resultsPerPage)
);

export const DEFAULT_NUMBER_OF_ITEMS_PER_PAGE = 10;

export const checkOrganizationalUnitsPrivilege = (activeRole) => (activeRole === ADMINISTRATOR || activeRole === UNIVERSITY || activeRole === UNIVERSITY_ADMIN);

export const checkFaculty = (activeRole) => (activeRole === FACULTY_ADMIN || activeRole === FACULTY || activeRole.substr(0, 18) === FACULTY_ADMIN);

export const checkWritePrivilege = (activeRole) => (activeRole === ADMINISTRATOR || activeRole === FACULTY_ADMIN);

export const formatListForDropdownOptions = (list) => list.map(el => ({
    ...el, key: el.id, value: el.id, text: el.name
}));



// WEBPACK FOOTER //
// ./src/views/Assets/util/util.js